import React, { createContext, useContext, useState } from 'react';

interface IntroVideoContextType {
  hasPlayedIntroVideo: boolean;
  setHasPlayedIntroVideo: (played: boolean) => void;
}

const IntroVideoContext = createContext<IntroVideoContextType>({
  hasPlayedIntroVideo: false,
  setHasPlayedIntroVideo: () => {},
});

export const IntroVideoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize state from sessionStorage or default to false
  const [hasPlayedIntroVideo, setHasPlayedIntroVideoState] = useState(() => {
    try {
      const savedState = sessionStorage.getItem('hasPlayedIntroVideo');
      return savedState === 'true';
    } catch (error) {
      console.error('Error reading from sessionStorage:', error);
      return false;
    }
  });

  // Update sessionStorage when state changes
  const setHasPlayedIntroVideo = (played: boolean) => {
    try {
      setHasPlayedIntroVideoState(played);
      sessionStorage.setItem('hasPlayedIntroVideo', played.toString());
    } catch (error) {
      console.error('Error writing to sessionStorage:', error);
      setHasPlayedIntroVideoState(played);
    }
  };

  return (
    <IntroVideoContext.Provider value={{ hasPlayedIntroVideo, setHasPlayedIntroVideo }}>
      {children}
    </IntroVideoContext.Provider>
  );
};

export const useIntroVideo = () => useContext(IntroVideoContext); 